<template>
  <div v-loading.fullscreen.lock="loading" class="order_success">        
    <div class="success_img">
      <div>
        <img src="@/images/icon_success.png" />
        <div>兑换成功</div>
      </div>
    </div>
    
    <div class="success_footer">
      <div @click="backToHome">返回商城</div>
      <div @click="toOrder">查看订单</div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
export default {
  data() {
    return {
      loading:false,
      category:''

    };
  },
  mounted () {
    this.category = this.$route.query.welfareCategory
  },
  methods:{
    backToHome(){
      this.$router.push({
        path: '/shoppingMall',
      })
    },
    toOrder(){
      this.$router.push({
        path: 'recordList',
        query: {
          welfareCategory:this.category
        }
      })
    },
  }
}
</script>
<style lang="stylus" type="stylesheet/stylus">
@import "../../assets/stylus/common"
  .order_success{
    height: 100vh;
    background: #FFF;
    .success_img {
      height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
      >div {
        img {
          width: 68px;
        }
        div {
          font-size:16px;
          font-family:PingFangSC-Semibold,PingFang SC;
          font-weight:600;
          color:rgba(53,53,53,1);
          margin-top: 16px;
        }
      }
    }
    .success_footer {
      display: flex;
      justify-content: space-between;
      padding: 17px;
      >div {
        width:160px;
        height:44px;
        border-radius:5px;
        font-size:16px;
        font-weight:500;
        font-family:PingFangSC-Medium,PingFang SC;
        text-align: center;
        line-height: 44px;
      }
      >div:nth-child(1){
        background:rgba(255,255,255,1);
        border:1px solid rgba(41,190,188,1);
        color:rgba(41,190,188,1);
      }
      >div:nth-child(2){
        background:rgba(41,190,188,1);
        color:#FFF;
      }
    }
  }
</style>